import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircle2, CalendarCheck } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

export default function KioskSuccess() {
  const navigate = useNavigate();
  const { type } = useParams();

  const isCheckin = type === "checkin";

  const successMessage = sessionStorage.getItem("successMessage");
  const isNewAppointment = successMessage === "marcada";

  useEffect(() => {
    const timer = setTimeout(() => {
      sessionStorage.removeItem("successMessage");
      navigate("/");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const goHome = () => {
    sessionStorage.removeItem("successMessage");
    navigate("/");
  };

  return (
    <div className="kiosk-mode min-h-screen bg-white flex flex-col items-center justify-center p-8">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="text-center max-w-2xl mx-auto"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.5, type: "spring" }}
          className="mb-8"
        >
          <div className="w-40 h-40 rounded-full bg-green-100 mx-auto flex items-center justify-center">
            {isCheckin ? (
              <CheckCircle2 className="w-24 h-24 text-green-600" strokeWidth={1.5} />
            ) : (
              <CalendarCheck className="w-24 h-24 text-green-600" strokeWidth={1.5} />
            )}
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <h1 className="text-5xl md:text-6xl font-bold text-slate-800 mb-6 font-['Outfit'] tracking-tight">
            {isCheckin
              ? "Check-in Realizado!"
              : isNewAppointment
              ? "Consulta Marcada!"
              : "Consulta Remarcada!"}
          </h1>

          <p className="text-2xl md:text-3xl text-slate-500 mb-4">
            {isCheckin
              ? "Sua presença foi confirmada com sucesso."
              : isNewAppointment
              ? "Sua consulta foi marcada com sucesso."
              : "Sua consulta foi remarcada com sucesso."}
          </p>

          <p className="text-xl text-slate-400 mb-12">
            {isCheckin
              ? "Por favor, aguarde ser chamado(a)."
              : "Você receberá uma confirmação por WhatsApp."}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="w-full max-w-md mx-auto mb-8"
        >
          <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 10, ease: "linear" }}
              className="h-full bg-[#003f7a]"
            />
          </div>
          <p className="text-sm text-slate-400 mt-2">Retornando à tela inicial...</p>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <Button
            data-testid="back-to-home-btn"
            onClick={goHome}
            className="kiosk-primary-btn"
          >
            Voltar ao Início
          </Button>
        </motion.div>
      </motion.div>
    </div>
  );
}